import { useLocation } from "react-router-dom";
import CarrouselSponsoredUno from "../components/carrouselSponsoredUno/carrouselSponsoredUno";

export default function CarrouselSponsoredUnoPage() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const momios = params.get("momios");
  const patrocinador = params.get("spon");

  return (
    <CarrouselSponsoredUno flagMomios={momios} patrocinador={patrocinador} />
  )

}